"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSchema = exports.dataSchema = exports.BodySchema = exports.method = exports.path = void 0;
exports.parseBody = parseBody;
exports.parseResponse = parseResponse;
const zod_1 = require("zod");
const common_1 = require("../../common");
// Здесь указываем path относительно основного роута
// например `${config.http.webUrl}` `${config.http.panelUrl}` `${config.http.backUrl}`
/** Относительно `${config.http.*}` */
exports.path = 'v2/get-one-meeting';
exports.method = common_1.HttpMethod.POST;
// #region Request
// Тело запроса. Optional
exports.BodySchema = zod_1.z.object({
  details: zod_1.z.array(common_1.meetingSchema.omit({
    id: true
  }).keyof()).optional()
}).and(zod_1.z.object({
  strategy: zod_1.z.literal('by-id'),
  filter: zod_1.z.object({
    id: zod_1.z.string().uuid()
  })
}).or(zod_1.z.object({
  strategy: zod_1.z.literal('by-slug'),
  filter: zod_1.z.object({
    slug: zod_1.z.string()
  })
})).or(zod_1.z.object({
  strategy: zod_1.z.literal('nearest')
})));
function parseBody(values) {
  return exports.BodySchema.parse(values);
}
// Параметры запроса. Optional
// export const ParamsSchema = z.object({});
// export type Params = z.infer<typeof ParamsSchema>;
// export function parseParams(values: Params) {
//   return ParamsSchema.parse(values);
// }
// Query параметры запроса. Optional
// export const QuerySchema = z.object({});
// export type Query = z.infer<typeof QuerySchema>;
// export function parseQuery(values: Query) {
//   return QuerySchema.parse(values);
// }
// #endregion
// #region Response
exports.dataSchema = zod_1.z.object({
  item: common_1.meetingSchema,
  debug: zod_1.z.array(zod_1.z.string()).optional()
});
exports.ResponseSchema = common_1.ApiResponse.infer(exports.dataSchema);
function parseResponse(values) {
  return exports.ResponseSchema.parse(values);
}
// #endregion
